import { Box, Typography } from '@drivekyte/ui';
import Image from 'next/image';
import Link from 'next/link';
import useFooterContent from '../../hooks/use-footer-content';
import Social from './components/social';

type FooterContentProps = {};

const FooterContent = ({}: FooterContentProps) => {
  const footerContent = useFooterContent();

  return (
    <Box
      paddingTop={64}
      paddingHorizontal={'$medium'}
      paddingBottom="$medium"
      maxWidth={1200}
      alignSelf="center"
      width="100%"
    >
      <Box
        columnGap="$medium"
        rowGap="$xLarge"
        alignSelf="stretch"
        flexDirection="column"
        display="flex"
        marginBottom={64}
        alignItems="flex-start"
        $gtMd={{ flexDirection: 'row' }}
      >
        <Box
          alignSelf="stretch"
          flexGrow={0}
          flexShrink={0}
          style={{ flex: 1 }}
        >
          <Image src="/logo.png" alt="Kyte logo" height={40} width={84} />
        </Box>
        {footerContent.map(({ sectionTitle, links }) => (
          <Box
            key={sectionTitle}
            gap="$small"
            flexGrow={0}
            flexShrink={0}
            style={{ flex: 1 }}
          >
            <Box alignSelf="stretch">
              <Typography variant="headingSmall">{sectionTitle}</Typography>
            </Box>

            {links.map(({ urlTitle, url, keepCurrentTab, onPress }, index) => (
              <Box key={url || `link-url-${index}`} alignSelf="flex-start">
                <Link
                  href={url || {}}
                  shallow={!!onPress}
                  onClick={onPress}
                  style={{ textDecoration: 'none' }}
                  target={url && !keepCurrentTab ? '_blank' : undefined}
                  aria-label={`footer-${urlTitle}-link`}
                >
                  <Typography variant="paragraphMedium">{urlTitle}</Typography>
                </Link>
              </Box>
            ))}
          </Box>
        ))}
      </Box>
      <Social />
    </Box>
  );
};

export default FooterContent;
